import React, { useEffect, useRef, useState } from "react";
import {
  Box as BoxKit,
  Stack as StackKit,
  Slider as SliderKit,
  Tooltip,
} from "@mui/material";
import RangeSlider from "react-range-slider-input";
import "react-range-slider-input/dist/style.css";
import { numberSeparator, toPersianNumber } from "@/hooks/useThousandsSeparator";
import TypoGraphyKit from "../../kit/typoGraphy";

interface PriceSliderBoxProps {
  value: number | string | undefined;
  setValue: any;
  min?: number | string | undefined;
  max?: number | string | undefined;
  min_month?: number | string | undefined;
  max_month?: number | string | undefined;
  direction?: "ltr" | "rtl";
  width?: string;
  step?: number;
}

const PriceSliderBox: React.FC<PriceSliderBoxProps> = ({
  min,
  max,
  setValue,
  value,
  direction = "ltr",
  max_month,
  min_month,
  width = "69%",
  step
}) => {
  const isRtl = direction === "rtl";
  const containerRef = useRef<HTMLDivElement | null>(null);

  const [thumbLeft, setThumbLeft] = useState<string>("0%");
  const [showTooltip, setShowTooltip] = useState<boolean>(false);
  const effectiveMin = Number(min ?? min_month ?? 0);
  const effectiveMax = Number(max ?? max_month ?? 100);
  const stepValue = step || 100;
  useEffect(() => {
    const hoverTarget = containerRef.current;

    if (hoverTarget) {
      const thumb = hoverTarget.querySelector(
        ".range-slider__thumb[data-upper='true']"
      ) as HTMLElement | null;

      if (thumb) {
        const left = thumb.style.left;
        if (left) setThumbLeft(left);
      }

      const handleMouseEnter = () => setShowTooltip(true);
      const handleMouseLeave = () => setShowTooltip(false);

      hoverTarget.addEventListener("mouseenter", handleMouseEnter);
      hoverTarget.addEventListener("mouseleave", handleMouseLeave);

      return () => {
        hoverTarget.removeEventListener("mouseenter", handleMouseEnter);
        hoverTarget.removeEventListener("mouseleave", handleMouseLeave);
      };
    }
  }, [value]);


  return (
    <StackKit
      direction={isRtl ? "row-reverse" : "row"}
      sx={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        justifyContent: "end",
      }}
    >
      <BoxKit
        sx={{
          bgcolor: "#136A74",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "0 10px",
          borderRadius: "10px",
          color: "#fff",
          minWidth: "120px",
          height: "37px",
        }}
      >
        {max_month ? (
          <div style={{ fontSize: "12px" }}>{toPersianNumber(max_month)} ماه</div>
        ) : (
          <div style={{ fontSize: "12px" }}>{numberSeparator(max)} ریال</div>
        )}
      </BoxKit>
      <BoxKit
        dir={isRtl ? "rtl" : "ltr"}
        sx={{
          width: "80%",
        }}
      >
        <div ref={containerRef} className="relative w-full">
          {showTooltip && (
            <div
              className="absolute -top-[50px] text-white text-xs"
              style={{ left: thumbLeft, transform: "translateX(-50%)" }}
            >
              <div className="relative bg-[#D9D9D9] text-black px-[30px] py-2 rounded-2xl text-sm text-center whitespace-nowrap">
                {min_month ? (
                  <StackKit direction={"row"} gap={1}>
                    <TypoGraphyKit variant="body1" sx={{ color: "#000" }}>
                      ماه
                    </TypoGraphyKit>
                    <TypoGraphyKit variant="body1" sx={{ color: "#000" }}>
                      {toPersianNumber(`${value}`)}
                    </TypoGraphyKit>
                  </StackKit>
                ) : (
                  <StackKit direction={"row"} gap={1}>
                    <TypoGraphyKit variant="body1" sx={{ color: "#000" }}>
                      ریال
                    </TypoGraphyKit>
                    <TypoGraphyKit variant="body1" sx={{ color: "#000" }}>
                      {numberSeparator(value)}
                    </TypoGraphyKit>
                  </StackKit>
                )}
                <div
                  className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0"
                  style={{
                    borderLeft: "6px solid transparent",
                    borderRight: "6px solid transparent",
                    borderTop: "7px solid #136A74",
                  }}
                />
              </div>
            </div>
          )}

          <RangeSlider
            className="single-thumb"
            defaultValue={[effectiveMin, Number(value)]}
            value={[effectiveMin, Number(value)]}
            onInput={([, val]: number[]) => setValue(val)}
            thumbsDisabled={[true, false]}
            rangeSlideDisabled
            min={effectiveMin}
            max={effectiveMax}
            step={stepValue}
          />
        </div>
      </BoxKit>
      <BoxKit
        sx={{
          width: "fit-content",
          bgcolor: "#136A74",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "0 10px",
          borderRadius: "10px",
          color: "#fff",
          gap: 2,
          minWidth: "120px",
          height: "37px",
        }}
      >
        {min_month ? (
          <div style={{ fontSize: "12px" }}>{toPersianNumber(min_month)} ماه </div>
        ) : (
          <div style={{ fontSize: "12px" }}>{numberSeparator(min)} ریال</div>
        )}
      </BoxKit>
    </StackKit>
  );
};

export default PriceSliderBox;
